import React from "react";

import { 
    Row,
    Col,
    Form,
    InputGroup,
} from "react-bootstrap-v5";
import styled from 'styled-components';

import Utils from "../../../../utils/utils";
import { InOrOut, BinOrWaste } from "../../../../utils/enums";

import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import CustomTooltip from '../../../../components/Tooltip/Tooltip';
import RSuiteAutoComplete from '../../../../components/OLD/Autocomplete/RSuiteAutoComplete';
import InputLayout from "../../../../components/input/InputLayout";

import { connect } from 'react-redux'
import { clear } from "../../../../../setup/redux/actions";
import { dispatchApiCallGet } from '../../../../../setup/redux/dispatch/actions'

import { ReactComponent as ScanTextIcon } from "../../../../../_metronic/assets/img/bin_center/scan_text.svg";


const StyledInputGroup = styled(InputGroup)`
    input {
        &:not(.disabled) {
            &:not([value=""]) {
                border-right: 0px;
            }
        }
    }

    .input-group-text {
        background-color: white;
        cursor: pointer;

        i {
            font-size: 14px;
            color: #8e8e93;
        }

        &:hover {
            i {
                color: #f44336;
            }
        }
    }
`;
const StyledInputReadOnly = styled(Form.Control)`
    border: 0px;
    padding-left: 5px;
    cursor: default;

    &[readonly]{
        color: #181C32 !important;
    }
`;


class StepOnTheSpotSection extends React.Component {
  
    constructor(props) {
        super(props);
        
        this.name = 'job_form_step_on_the_spot_section';

        let dataParams = (props.dataParams) ? props.dataParams : null;
        let id = (dataParams && dataParams.id) ? dataParams.id : null;
        let row = (dataParams && dataParams.row) ? dataParams.row : null;
        
        this.pageRef = React.createRef();

        this.state = {
            id: id,
            row: row,
        };
    }
    

    componentWillReceiveProps(nextProps) {
        this.reduxProps(nextProps);
    }


    /* API */
    reduxProps = nextProps => {
        Utils.reduxProps(nextProps,
            this.name + '-binnumber', 
            (data, isLoading, isError, err, statusCode, variables, callback) => {
                let arr = [];

                if(data && data.data && data.data.length > 0) {
                    for (var i = 0; i < data.data.length; i++) {
                        let item = data.data[i];
                        let value = item.binNumberId;
                        let title = item.binNumberName;
                        let arrItem = {
                            index: i,
                            value: value,
                            title: title,
                            label: title,
                            item: item,
                        };

                        arr = Utils.addToArray(arr, value, arrItem);
                    }
                }

                this.setState({
                    isLoading: isLoading,
                    isError: isError,
                    err: err,
                }, () => {
                    this.props.clear();

                    if(callback){
                        callback(arr);
                    }
                });
            }
        );
    }
	
    callBinNumberReadApi = (binTypeId = null, items, searchQuery = '', callback = null) => {
        let {
            values,
        } = this.props.formOptions;

        let data = {
            currentPage: 1,
            pageSize: Utils.getMaxPageSize(),
            searchQuery: searchQuery,
            binTypeId: binTypeId,
            customerSiteId: values.customerSiteId,
            customerId: values.customerId,
            showRecentJob: true,
        };

        this.props.dispatchApiCallGet(data, this.name + '-binnumber', 'binnumber', { items: items }, callback, () => {});
    }
    /* END API */


    body = () => {
        let {
            handleChange,
            setFieldValue,
            validateForm,
            values,
            errors,
        } = this.props.formOptions;
        
        let isDisabled = values.isParams || Utils.isRecurringFormAndisActive(values.isRecurringForm, values.isActive) || !(values.customerSiteId) || Utils.isCancelledOrFailed(values.currentStatusName);
        let isDisabledWaste = values.isParams || Utils.isRecurringFormAndisActive(values.isRecurringForm, values.isActive) || !(values.customerSiteId) || !(values.stepOnTheSpotBinTypeId) || Utils.isCancelledOrFailed(values.currentStatusName);
        let isDisabledWeightChit = Utils.isCancelledOrFailed(values.currentStatusName);

        return <Row className={''}>
            <Col xs={12} md={6}>
                <Row className={''}>
                    <Col xs={12}>
                        <h3 className={'mb-7'}>
                            <span style={{ color: '#DFDFDF' }}>WASTE IN</span>
                            <CustomTooltip placement={'right'} title={'You collect waste from sites and dispose at yard.'}>
                                <InfoOutlinedIcon style={{ color: '#DFDFDF', width: '30px', height: '25px' }} />
                            </CustomTooltip>
                        </h3>
                    </Col>
                    <Col xs={12}>
                        <Row>
                            <Col xs={12}>
                                <InputLayout
                                    label={this.props.fields.stepOnTheSpotBinTypeId.label}
                                    required
                                >
                                    <StyledInputGroup>
                                        <Form.Control
                                            className={'custom-readonly-bin-waste-field ' + (isDisabled ? 'disabled': '')}
                                            id={this.props.fields.stepOnTheSpotBinTypeId.id}
                                            placeholder={this.props.fields.stepOnTheSpotBinTypeId.placeholder}
                                            readOnly={true}
                                            value={values.stepOnTheSpotBinTypeName}
                                            isInvalid={!!errors.stepOnTheSpotBinTypeId}
                                            onClick={(e) => {
                                                if(!isDisabled){
                                                    if(this.props.onBinWasteSidePanel){
                                                        this.props.onBinWasteSidePanel(InOrOut.IN, BinOrWaste.BIN);
                                                    }
                                                }
                                            }}
                                        />
                                        {(!isDisabled && values.stepOnTheSpotBinTypeName != null && values.stepOnTheSpotBinTypeName != '') && <InputGroup.Text
                                            onClick={(e) => {
                                                if(this.props.onBinWasteClear){
                                                    this.props.onBinWasteClear(InOrOut.IN, BinOrWaste.BIN);
                                                }
                                            }}
                                        >
                                            <i className={'material-icons'}>close</i>
                                        </InputGroup.Text>}
                                        <Form.Control.Feedback type="invalid">{errors.stepOnTheSpotBinTypeId}</Form.Control.Feedback>
                                    </StyledInputGroup>
                                </InputLayout>
                            </Col>
                            <Col xs={12}>
                                <InputLayout
                                    label={this.props.fields.stepOnTheSpotWasteTypeIds.label}
                                    required
                                >
                                    <StyledInputGroup>
                                        <Form.Control
                                            className={'custom-readonly-bin-waste-field ' + (isDisabledWaste ? 'disabled': '')}
                                            id={this.props.fields.stepOnTheSpotWasteTypeIds.id}
                                            placeholder={this.props.fields.stepOnTheSpotWasteTypeIds.placeholder}
                                            readOnly={true}
                                            value={values.stepOnTheSpotWasteTypeIds ? values.customFormParams.stepOnTheSpotWasteTypeItems.filter(item => values.stepOnTheSpotWasteTypeIds.includes(item.value)).map(x => x.title).join(', ') : ''}
                                            isInvalid={!!errors.stepOnTheSpotWasteTypeIds}
                                            onClick={(e) => {
                                                if(!isDisabledWaste){
                                                    if(this.props.onBinWasteSidePanel){
                                                        this.props.onBinWasteSidePanel(InOrOut.IN, BinOrWaste.BIN);
                                                    }
                                                }
                                            }}
                                        />
                                        {(!isDisabledWaste && (values.stepOnTheSpotWasteTypeIds ? values.customFormParams.stepOnTheSpotWasteTypeItems.filter(item => values.stepOnTheSpotWasteTypeIds.includes(item.value)).map(x => x.title).join(', ') : '') != '') && <InputGroup.Text
                                            onClick={(e) => {
                                                if(this.props.onBinWasteClear){
                                                    this.props.onBinWasteClear(InOrOut.IN, BinOrWaste.BIN);
                                                }
                                            }}
                                        >
                                            <i className={'material-icons'}>close</i>
                                        </InputGroup.Text>}
                                        <Form.Control.Feedback type="invalid">{errors.stepOnTheSpotWasteTypeIds}</Form.Control.Feedback>
                                    </StyledInputGroup>
                                </InputLayout>
                            </Col>
                            <Col xs={12}>
                                <InputLayout
                                    label={this.props.fields.stepOnTheSpotBinNumber.label}
                                >
                                    <InputGroup>
                                    <Form.Control
                                        as = {RSuiteAutoComplete}
                                        isInvalid={!!errors.stepOnTheSpotBinNumber}

                                        id={this.props.fields.stepOnTheSpotBinNumber.id}
                                        placeholder={this.props.fields.stepOnTheSpotBinNumber.placeholder}
                                        items={values.customFormParams.stepOnTheSpotBinNumberItems}
                                        value={values.stepOnTheSpotBinNumber}
                                        isLoading={values.customFormParams.stepOnTheSpotBinNumberIsLoading}
                                        disabled={values.isParams || Utils.isRecurringFormAndisActive(values.isRecurringForm, values.isActive) || !(values.customerSiteId) || !(values.stepOnTheSpotBinTypeId) || Utils.isCancelledOrFailed(values.currentStatusName)}
                                        labelKey={'title'}
                                        isDefault={true}
                                        pattern={Utils.max7chars()}
                                        renderMenuItem={(label, item) => {
                                            let minDate = Utils.getMinDate();
                                            let lastJobDate = (item && item.item && item.item.lastJobDate) ? item.item.lastJobDate : minDate;

                                            return <div className={'d-flex align-items-center'}>
                                                {((lastJobDate !== minDate) && (item.index < 5)) ? <i className={'material-icons'}>access_time</i> : null}
                                                <span className={'ps-2'}>{item.title}</span>
                                            </div>
                                        }}
                                        onClick={async () => {
                                            await setFieldValue('customFormParams.stepOnTheSpotBinNumberIsLoading', true);
                                            this.callBinNumberReadApi(values.stepOnTheSpotBinTypeId, values.customFormParams.stepOnTheSpotBinNumberItems, '', async (items) => {
                                                await setFieldValue('customFormParams.stepOnTheSpotBinNumberItems', items);
                                                await setFieldValue('customFormParams.stepOnTheSpotBinNumberIsLoading', false);
                                            });
                                        }}
                                        onSearch={async (value) => {
                                            await setFieldValue('stepOnTheSpotisUsingQr', false);
                                            await setFieldValue('stepOnTheSpotisUsingTextDetection', false);
                                            await setFieldValue('customFormParams.isSameAsBinOut', false);
                                            await setFieldValue('customFormParams.stepOnTheSpotBinNumberIsLoading', true);
                                            this.callBinNumberReadApi(values.stepOnTheSpotBinTypeId, values.customFormParams.stepOnTheSpotBinNumberItems, value, async (items) => {
                                                await setFieldValue('customFormParams.stepOnTheSpotBinNumberItems', items);
                                                await setFieldValue('customFormParams.stepOnTheSpotBinNumberIsLoading', false);
                                            });
                                        }}
                                        onChange={async (value) => {
                                            await setFieldValue('stepOnTheSpotisUsingQr', false);
                                            await setFieldValue('stepOnTheSpotisUsingTextDetection', false);
                                            await setFieldValue('stepOnTheSpotBinNumber', value);
                                            await setFieldValue('customFormParams.isSameAsBinOut', false);
                                        }}
                                        onSelect={async (value, item) => {
                                            await setFieldValue('stepOnTheSpotisUsingQr', false);
                                            await setFieldValue('stepOnTheSpotisUsingTextDetection', false);
                                            await setFieldValue('stepOnTheSpotBinNumber', value);
                                            await setFieldValue('customFormParams.isSameAsBinOut', false);
                                        }}
                                    />
                                    {values.stepOnTheSpotisUsingQr && <CustomTooltip title={'QR code is scanned'}>
                                        <i style={{ position: 'absolute', right: '15px', top: '15px' }} class="fa fa-qrcode"></i>
                                    </CustomTooltip>}
                                    {values.stepOnTheSpotisUsingTextDetection && <CustomTooltip title={'QR code is scanned with text recognition'}>
                                        <ScanTextIcon style={{ position: 'absolute', right: '14px', top: '15px', width: '15px', height: '15px' }} />
                                    </CustomTooltip>}
                                    <Form.Control.Feedback type="invalid">{errors.stepOnTheSpotBinNumber}</Form.Control.Feedback>
                                    </InputGroup>
                                </InputLayout>
                            </Col>
                            {!values.isRecurringForm && <Col xs={12}>
                                <InputLayout
                                    label={<>
                                        <span>{this.props.fields.stepBinWeight.label}</span>
                                        <CustomTooltip placement={'right'} title={'Gross Weight (This) - Tare Weight - Non billable Weight = Billable Weight'}>
                                            <InfoOutlinedIcon style={{ color: '#DFDFDF', width: '30px', height: '25px' }} />
                                        </CustomTooltip>
                                    </>}
                                >
                                    <Form.Control
                                        className={'custom-readonly-bin-weight-field ' + (isDisabledWeightChit ? 'disabled': '')}
                                        id={this.props.fields.stepBinWeight.id}
                                        placeholder={this.props.fields.stepBinWeight.placeholder}
                                        readOnly={true}
                                        value={values.stepBinWeight}
                                        isInvalid={!!errors.stepBinWeight}
                                        onClick={(e) => {
                                            if(!isDisabledWeightChit){
                                                if(this.props.onWeighChitSidePanel){
                                                    this.props.onWeighChitSidePanel();
                                                }
                                            }
                                        }}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.stepBinWeight}</Form.Control.Feedback>
                                </InputLayout>
                            </Col>}
                            
                            <Col xs={12}>
                                <InputLayout
                                    label={'Service name'}
                                    inputProps={{
                                        className: 'd-flex align-items-center'
                                    }}
                                >
                                    <div>
                                        <span className={'pe-2'}>{values.stepOnTheSpotServiceItemName}</span>
                                        {(values.stepOnTheSpotServiceItemIsGlobal && (values.stepOnTheSpotServiceItemName != '')) && <CustomTooltip placement={'top'} title={'Global service'}>
                                            <i className={'material-icons'} style={{ position: 'relative', top: '6px', fontSize: '22px', }}>public</i>
                                        </CustomTooltip>}
                                    </div>
                                </InputLayout>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
        </Row>
    }
    

    render() {
        return <div ref={this.pageRef}>
            {this.body()}
        </div>
    }
}

const mapDispatchToProps = {
  dispatchApiCallGet,
  clear,
}

export default connect(Utils.mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(StepOnTheSpotSection);
